import { render, staticRenderFns } from "./FilaAtendimentoChat.vue?vue&type=template&id=74ca8576&"
import script from "./FilaAtendimentoChat.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimentoChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports